import React, { useState, useEffect } from "react";
import NewsItem from "./NewsItem";
import useGetAllArticles from "../../Api/News/useGetAllArticles";
import Loading from "../Loading";

type Props = {
    Count: number | string
}

export default function NewsList({ Count }: Props) {
    const { data, isLoading, refetch } = useGetAllArticles();

    useEffect(() => {
        console.log(data);
    }, [data])

    return (
        <>
            {!data && <Loading pos={"absolute"} /> }
            {data &&
                data.splice(0, Count).map(item =>
                    <NewsItem
                        data={item.Article}
                        picture={item.MediaFile}
                    />
                )
            }
        </>
    )
} 